"use server";

import { z } from "zod";
import { auth, signIn, signOut, entraConfigured } from "@/auth";
import { redirect } from "next/navigation";
import { requireUserId } from "@/lib/action-guards";

/**
 * Signs out the current user and initiates Microsoft Entra sign-in.
 * - If loginHint is provided, starts Microsoft sign-in with login_hint and no prompt, so an account that is still
 *   signed in to Microsoft in this browser switches without asking for a password (owner, 2026-11-02).
 * - If loginHint is not provided ("Add another account"), starts Microsoft sign-in with prompt=select_account without login_hint.
 * - If Microsoft Entra is not configured, redirects to /login.
 */
export async function switchAccountAction(formData?: FormData) {
  await requireUserId();
  const parsed = z.string().trim().email().max(254).safeParse(formData?.get("loginHint"));
  const loginHint = parsed.success ? parsed.data : undefined;

  await signOut({ redirect: false });

  if (!entraConfigured) {
    redirect(loginHint ? `/login?email=${encodeURIComponent(loginHint)}` : "/login");
  }

  const authParams: Record<string, string> = loginHint ? { login_hint: loginHint } : { prompt: "select_account" };

  await signIn("microsoft-entra-id", { redirectTo: "/" }, authParams);
}

/** Signs the current account out of the Hub. */
export async function signOutAction() {
  if (!(await auth())) redirect("/login");
  await signOut({ redirectTo: "/login" });
}
